<template>
	<div>
		<div class="title-area">
			<div class="back" @click="$router.back()">
				<i class="el-icon-arrow-left"></i>
			</div>
			<div>{{ $t(`text21`) }}</div>
		</div>
		<div class="content-area">
			<div class="content">
				<div class="item-area">
					<div
						class="icon ending"
						v-if="[3].includes(afterSalesOrder.State)"
					>
						<img class="image" src="@/assets/icon-2.png" alt="" />
						<span>{{ $t(`text22`) }}</span>
					</div>
					<div
						class="icon"
						v-if="[1, 2].includes(afterSalesOrder.State)"
					>
						<img class="image" src="@/assets/icon-1.png" alt="" />
						<span>{{ $t(`text23`) }}</span>
					</div>
					<div class="item-title">{{ $t(`text24`) }}</div>
					<div class="item-txt">
						{{ $t(`text25`) }}：{{ afterSalesOrder.ProjectName }}
					</div>
					<div class="item-txt">
						{{ $t(`text26`) }}：{{ afterSalesOrder.UnitNumber }}
					</div>
					<div class="item-txt">
						{{ $t(`text27`) }}：{{ afterSalesOrder.CreateOn }}
					</div>
				</div>
				<el-timeline>
					<el-timeline-item
						color="#135192"
						timestamp=""
						placement="top"
						v-for="(item, index) in followList"
						:key="index"
					>
						<div class="timeline-content">
							<div class="content-item">
								<div class="time">{{ item.CreateOn }}</div>
								<div class="file" v-if="item.URL">
									<i class="el-icon-paperclip"></i>
									<div class="txt">{{ $t(`text28`) }}</div>
								</div>
							</div>
							<div class="content-item" style="margin-top: 10px;">
								<div class="font" v-html="item.Content"></div>
								<div
									class="btn"
									v-if="item.URL"
									@click="handleFileList(item.File)"
								>
									{{ $t(`text29`) }}
								</div>
							</div>
						</div>
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>
		<el-dialog
			:title="$t(`text28`)"
			width="80%"
			:visible.sync="dialogVisible"
		>
			<div
				class="file-area"
				v-for="(item, index) in fileList"
				:key="index"
			>
				<span>{{ item.name }}</span>
				<a class="btn" :href="item.url" target="_blank">
					{{ $t(`text29`) }}
				</a>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getAfterSalesOrder, aftersalesFollowList } from "@/api/qrcode";

export default {
	components: {},
	data() {
		return {
			afterSalesOrder: {},
			followList: [],
			dialogVisible: false,
			fileList: [],
		};
	},
	mounted() {
		this.getAfterSalesOrderData();
		this.getFollowList();
	},
	methods: {
		async getAfterSalesOrderData() {
			let params = {
				id: this.$route.params.id,
			};
			let { Data } = await getAfterSalesOrder(params);
			this.afterSalesOrder = Data;
		},
		async getFollowList() {
			let params = {
				OrderId: this.$route.params.id,
				Page: 1,
				PerPage: 1000,
			};
			let { Data } = await aftersalesFollowList(params);
			this.followList = Data.filter((item) => {
				if (item.URL) {
					item.File = JSON.parse(item.URL);
				}
				return item.ShopPage;
			});
		},
		handleFileList(e) {
			this.dialogVisible = true;
			this.fileList = e;
		},
	},
};
</script>

<style lang="scss">
.font {
	font-size: 14px;
	img {
		display: block;
		width: 100%;
	}
}
</style>

<style scoped lang="scss">
::v-deep .el-icon-paperclip {
	color: #687dcb;
}

.title-area {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 45px;
	font-size: 24px;
	font-size: 0.5rem;
	.back {
		font-size: 24px;
		position: absolute;
		top: 50%;
		left: 5px;
		transform: translateY(-50%);
	}
}
.content-area {
	position: fixed;
	left: 0;
	right: 0;
	top: 45px;
	bottom: 0;
	background-color: #7b8194;
	padding: 10px;
	.content {
		position: absolute;
		inset: 10px;
		padding: 10px;
		background-color: #fff;
		border-radius: 10px;
		overflow-y: auto;
		.item-area {
			position: relative;
			padding: 15px;
			margin-bottom: 30px;
			border-radius: 10px;
			background: #fff;
			border: 1px solid #135192;
			overflow: hidden;

			.icon {
				position: absolute;
				right: 0;
				top: 0;
				display: flex;
				align-items: center;
				padding: 5px 10px;
				color: #f45f19;
				font-size: 14px;
				border-radius: 0 0 0 20px;
				background-color: #fdceb3;
				.image {
					width: 25px;
					margin-right: 5px;
				}
			}
			.ending {
				background: #c7f8f4;
				color: #62eddb;
			}
			.item-title {
				font-size: 18px;
			}
			.item-txt {
				font-size: 14px;
				margin-top: 8px;
				color: #aaa;
			}
		}
		.timeline-content {
			padding: 15px;
			border-radius: 10px;
			background: #fff;
			// border: 1px solid #6f7ba5;
			box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
			font-size: 14px;
			.content-item {
				display: flex;
				justify-content: space-between;
				align-items: start;
				.time {
					color: #aaa;
				}
				.file {
					display: flex;
					align-items: center;
					.icon {
					}
					.txt {
						color: #135192;
						font-size: 14px;
						margin-left: 5px;
					}
				}
				.font {
					font-size: 14px;
				}
				.btn {
					flex-shrink: 0;
					padding: 2px 10px;
					background-color: #135192;
					color: #fff;
					font-size: 14px;
					text-align: center;
					border-radius: 20px;
				}
			}
		}
	}
}
.file-area {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 20px;
	.btn {
		flex-shrink: 0;
		padding: 2px 10px;
		background-color: #135192;
		color: #fff;
		font-size: 14px;
		text-align: center;
		border-radius: 20px;
	}
}
</style>
